export default "/images/d55fe37e2bc73414b2a25658dcf3b4f5.avif";